import { IPreFilter, IPageInfo, IDeaEditMode } from '../interfaces';

export enum CsaFilterOptions {
  'TaxId' = 'TaxId',
  // 'SSN' = 'SSN',
  'NPI' = 'NPI',
  'DEANum' = 'DEA Number',
}

export type DeaFilterFunction = (a: IPreFilter, b: IPageInfo) => void;
export type DeaVoidFunction = () => void;
export type DeaNumFunction = (a: IDeaEditMode) => void;
export type DeaPageFunction = (a: IPageInfo) => void;

export const CSA_FILTER_ROWS_PER_PAGE = 10;
export const CSA_FILTER_ROWS_PER_PAGE_OPTION = [10, 25, 50, 100, 500];
export const CSA_FILTER_DEF_MAX_PAGE = CSA_FILTER_ROWS_PER_PAGE_OPTION[0];

export const USA_STATES = [
  {
    name: '',
    value: '',
    label: '(Empty)',
  },
  {
    name: 'Alabama',
    value: 'AL',
    label: 'AL',
  },
  {
    name: 'Alaska',
    value: 'AK',
    label: 'AK',
  },
  {
    name: 'American Samoa',
    value: 'AS',
    label: 'AS',
  },
  {
    name: 'Arizona',
    value: 'AZ',
    label: 'AZ',
  },
  {
    name: 'Arkansas',
    value: 'AR',
    label: 'AR',
  },
  {
    name: 'California',
    value: 'CA',
    label: 'CA',
  },
  {
    name: 'Colorado',
    value: 'CO',
    label: 'CO',
  },
  {
    name: 'Connecticut',
    value: 'CT',
    label: 'CT',
  },
  {
    name: 'Delaware',
    value: 'DE',
    label: 'DE',
  },
  {
    name: 'District Of Columbia',
    value: 'DC',
    label: 'DC',
  },
  {
    name: 'Federated States Of Micronesia',
    value: 'FM',
    label: 'FM',
  },
  {
    name: 'Florida',
    value: 'FL',
    label: 'FL',
  },
  {
    name: 'Georgia',
    value: 'GA',
    label: 'GA',
  },
  {
    name: 'Guam',
    value: 'GU',
    label: 'GU',
  },
  {
    name: 'Hawaii',
    value: 'HI',
    label: 'HI',
  },
  {
    name: 'Idaho',
    value: 'ID',
    label: 'ID',
  },
  {
    name: 'Illinois',
    value: 'IL',
    label: 'IL',
  },
  {
    name: 'Indiana',
    value: 'IN',
    label: 'IN',
  },
  {
    name: 'Iowa',
    value: 'IA',
    label: 'IA',
  },
  {
    name: 'Kansas',
    value: 'KS',
    label: 'KS',
  },
  {
    name: 'Kentucky',
    value: 'KY',
    label: 'KY',
  },
  {
    name: 'Louisiana',
    value: 'LA',
    label: 'LA',
  },
  {
    name: 'Maine',
    value: 'ME',
    label: 'ME',
  },
  {
    name: 'Marshall Islands',
    value: 'MH',
    label: 'MH',
  },
  {
    name: 'Maryland',
    value: 'MD',
    label: 'MD',
  },
  {
    name: 'Massachusetts',
    value: 'MA',
    label: 'MA',
  },
  {
    name: 'Michigan',
    value: 'MI',
    label: 'MI',
  },
  {
    name: 'Minnesota',
    value: 'MN',
    label: 'MN',
  },
  {
    name: 'Mississippi',
    value: 'MS',
    label: 'MS',
  },
  {
    name: 'Missouri',
    value: 'MO',
    label: 'MO',
  },
  {
    name: 'Montana',
    value: 'MT',
    label: 'MT',
  },
  {
    name: 'Nebraska',
    value: 'NE',
    label: 'NE',
  },
  {
    name: 'Nevada',
    value: 'NV',
    label: 'NV',
  },
  {
    name: 'New Hampshire',
    value: 'NH',
    label: 'NH',
  },
  {
    name: 'New Jersey',
    value: 'NJ',
    label: 'NJ',
  },
  {
    name: 'New Mexico',
    value: 'NM',
    label: 'NM',
  },
  {
    name: 'New York',
    value: 'NY',
    label: 'NY',
  },
  {
    name: 'North Carolina',
    value: 'NC',
    label: 'NC',
  },
  {
    name: 'North Dakota',
    value: 'ND',
    label: 'ND',
  },
  {
    name: 'Northern Mariana Islands',
    value: 'MP',
    label: 'MP',
  },
  {
    name: 'Ohio',
    value: 'OH',
    label: 'OH',
  },
  {
    name: 'Oklahoma',
    value: 'OK',
    label: 'OK',
  },
  {
    name: 'Oregon',
    value: 'OR',
    label: 'OR',
  },
  {
    name: 'Palau',
    value: 'PW',
    label: 'PW',
  },
  {
    name: 'Pennsylvania',
    value: 'PA',
    label: 'PA',
  },
  {
    name: 'Puerto Rico',
    value: 'PR',
    label: 'PR',
  },
  {
    name: 'Rhode Island',
    value: 'RI',
    label: 'RI',
  },
  {
    name: 'South Carolina',
    value: 'SC',
    label: 'SC',
  },
  {
    name: 'South Dakota',
    value: 'SD',
    label: 'SD',
  },
  {
    name: 'Tennessee',
    value: 'TN',
    label: 'TN',
  },
  {
    name: 'Texas',
    value: 'TX',
    label: 'TX',
  },
  {
    name: 'Utah',
    value: 'UT',
    label: 'UT',
  },
  {
    name: 'Vermont',
    value: 'VT',
    label: 'VT',
  },
  {
    name: 'Virgin Islands',
    value: 'VI',
    label: 'VI',
  },
  {
    name: 'Virginia',
    value: 'VA',
    label: 'VA',
  },
  {
    name: 'Washington',
    value: 'WA',
    label: 'WA',
  },
  {
    name: 'West Virginia',
    value: 'WV',
    label: 'WV',
  },
  {
    name: 'Wisconsin',
    value: 'WI',
    label: 'WI',
  },
  {
    name: 'Wyoming',
    value: 'WY',
    label: 'WY',
  },
];
